import React, { useRef } from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import MedicalResultUnsavedChangesModal from "./MedicalResultUnsavedChangesModal";
import FileDropzone from "@dhn/components/molecules/file-dropzone";
import FileList from "@dhn/components/molecules/file-list";
import DocumentsSizeProgress from "@dhn/components/molecules/documents-size-progress";
import { getFilesTotalBytes } from "./result-files";
import ModalHeader from "@dhn/components/molecules/modal-header";
import "./medical-results.scss";

export default function MedicalResultsModal({
  isOpen,
  toggle,
  title,
  canManageResults,
  resultDate,
  onChangeResultDate,
  resultLabel,
  onChangeResultLabel,
  labelPlaceholder,
  getRootProps,
  getInputProps,
  files,
  appointmentUsedBytes,
  onRemoveLocalFile,
  onAddResult,
  addButtonLabel,
  errorMessage,
  resultRecords,
  columnsResults,
  emptyText,
  isDiscardConfirmationOpen,
  onContinueEditing,
  onDiscardAndClose,
}) {
  const labelInputRef = useRef(null);
  const totalBytes = Number(
    appointmentUsedBytes ?? getFilesTotalBytes(files),
  );
  const focusLabelInput = () => {
    if (canManageResults && labelInputRef.current) {
      labelInputRef.current.focus();
    }
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle} onOpened={focusLabelInput} centered>
      <ModalHeader
        toggle={toggle}
        iconClass="fa-flask"
        description={title}
        subtitle="Agregue o revise los resultados de laboratorio e imágenes de la cita."
      />
      <ModalBody>
        {canManageResults ? (
          <Card className="mb-3">
            <CardBody>
              <Row form>
                <Col lg="5" className="mb-3">
                  <Label>Etiqueta:</Label>
                  <Input
                    innerRef={(input) => {
                      labelInputRef.current = input;
                    }}
                    type="text"
                    placeholder={labelPlaceholder}
                    value={resultLabel}
                    onChange={({ target: { value } }) => onChangeResultLabel(value)}
                  />
                </Col>
                <Col lg="3" md="6" className="mb-3">
                  <Label>Fecha Resultado:</Label>
                  <DatePicker
                    selected={resultDate ? moment(resultDate).toDate() : null}
                    placeholderText="dd/MM/yyyy"
                    dateFormat="dd/MM/yyyy"
                    className="mi-input form-control"
                    calendarClassName="mi-calendar"
                    onChange={(item) =>
                      onChangeResultDate(item ? moment(item).format("YYYY-MM-DD") : "")
                    }
                  />
                </Col>
                <Col lg="4" md="6" className="d-flex align-items-end justify-content-end mb-3">
                  <Button
                    type="button"
                    size="sm"
                    color="success"
                    className="btn-color-success medical-results-add-button"
                    onClick={onAddResult}
                  >
                    <i className={`fa ${addButtonLabel ? "fa-save" : "fa-plus"}`} />
                    {` ${addButtonLabel || "Agregar resultado"}`}
                  </Button>
                </Col>
              </Row>

              <FileDropzone
                title="Arrastre los archivos aquí o haga clic para seleccionarlos"
                description="JPG, PNG o PDF · Máximo 5 archivos por resultado · 8 MB por cita"
                getRootProps={getRootProps}
                getInputProps={getInputProps}
              />
              <FileList
                items={files.map((fileItem) => ({
                  key: fileItem.localId || fileItem.id,
                  localId: fileItem.localId,
                  name: fileItem.originalName,
                  size: fileItem.sizeBytes,
                  type: fileItem.mimetype,
                }))}
                grid
                onRemove={({ localId }) => onRemoveLocalFile(localId)}
              />
            </CardBody>
          </Card>
        ) : null}

        {errorMessage ? <Alert color="danger" className="py-2">{errorMessage}</Alert> : null}

        <Card className="mb-0">
          <CardBody>
            <ReactTable
              data={resultRecords}
              defaultPageSize={5}
              noDataText={emptyText}
              className="-striped -highlight"
              columns={columnsResults}
            />
          </CardBody>
        </Card>

        <DocumentsSizeProgress
          className="mb-0"
          title="Límite de archivos de Laboratorios e Imágenes para esta cita"
          description={null}
          totalSize={totalBytes}
        />
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="danger" className="btn-color-danger" onClick={toggle}>
          <i className="fa fa-times" aria-hidden="true" />
          {" Cerrar"}
        </Button>
      </ModalFooter>

      <MedicalResultUnsavedChangesModal
        isOpen={isDiscardConfirmationOpen}
        onContinueEditing={onContinueEditing}
        onDiscard={onDiscardAndClose}
      />
    </Modal>
  );
}
